import {BASE_URL} from "../../config/network";
import {NEWWAY_WEB_CLIENT_APP_VERSION} from "../../config/appVersion";

const getBrowserBrand = (userAgentData) => {
    const brands = userAgentData?.brands || userAgentData?.uaList || [];
    const preferredBrand = brands.find((brand) => (
        brand?.brand && !/not|chromium/i.test(brand.brand)
    )) || brands.find((brand) => brand?.brand);

    if (!preferredBrand?.brand) return "";
    return `${preferredBrand.brand}${preferredBrand.version ? ` ${preferredBrand.version}` : ""}`;
};

const parseOsFromUserAgent = (userAgent = "") => {
    const ua = String(userAgent || "");

    const iosMatch = ua.match(/(?:iPhone|iPad|iPod).*OS\s([\d_]+)/i);
    if (iosMatch) {
        return {
            os: "iOS",
            version: iosMatch[1].replace(/_/g, "."),
        };
    }

    const androidMatch = ua.match(/Android\s([\d.]+)/i);
    if (androidMatch) {
        return {
            os: "Android",
            version: androidMatch[1],
        };
    }

    const windowsMatch = ua.match(/Windows NT\s([\d.]+)/i);
    if (windowsMatch) {
        return {
            os: "Windows",
            version: windowsMatch[1],
        };
    }

    const macMatch = ua.match(/Mac OS X\s([\d_]+)/i);
    if (macMatch) {
        return {
            os: "macOS",
            version: macMatch[1].replace(/_/g, "."),
        };
    }

    const linuxMatch = ua.match(/Linux/i);
    if (linuxMatch) {
        return {
            os: "Linux",
            version: "",
        };
    }

    return {
        os: "",
        version: "",
    };
};

const getClientTechnicalSpec = async () => {
    if (typeof window === "undefined") {
        return {
            "tr.settings.type": "website",
            "technical_spec.app_version": NEWWAY_WEB_CLIENT_APP_VERSION,
            "technical_spec.phone_model": "web",
            "technical_spec.phone_os": "unknown",
            "technical_spec.phone_os_version": "",
        };
    }

    const userAgent = window.navigator?.userAgent || "";
    const userAgentData = window.navigator?.userAgentData;
    const parsedOs = parseOsFromUserAgent(userAgent);
    let highEntropyValues = {};

    if (typeof userAgentData?.getHighEntropyValues === "function") {
        try {
            highEntropyValues = await userAgentData.getHighEntropyValues([
                "model",
                "platform",
                "platformVersion",
            ]);
        } catch (_error) {
            highEntropyValues = {};
        }
    }

    const browserBrand = getBrowserBrand(userAgentData);
    const platform = highEntropyValues.platform || userAgentData?.platform || parsedOs.os || "unknown";
    const model = highEntropyValues.model || browserBrand || "web";

    return {
        "tr.settings.type": "kav2goapp",
        "technical_spec.app_version": NEWWAY_WEB_CLIENT_APP_VERSION,
        "technical_spec.phone_model": model,
        "technical_spec.phone_os": platform,
        "technical_spec.phone_os_version": highEntropyValues.platformVersion || parsedOs.version || "",
    };
};

const getResponseJson = async (response) => {
    try {
        return await response.json();
    } catch (_error) {
        return null;
    }
};

const idsfTransactionGroupStartAPI = async (payload = {}) => {
    const URL = `${BASE_URL}/public/id-sugarfree/transaction-group-website-start`;
    const METHOD = "POST";
    const HEADERS = {
        Accept: "application/json",
        "Content-Type": "application/json",
        "mobielrijden-client-app-version": NEWWAY_WEB_CLIENT_APP_VERSION,
    };
    const technicalSpecPayload = await getClientTechnicalSpec();
    const requestPayload = {
        ...technicalSpecPayload,
        ...payload,
    };

    const response = await fetch(URL, {
        method: METHOD,
        headers: HEADERS
    });
    const responseJson = await getResponseJson(response);

    if (!response.ok) {
        const errorMessage = responseJson?.error?.message || responseJson?.message || `HTTP error: ${response.status}`;
        throw new Error(errorMessage);
    }

    return responseJson;
};

export {idsfTransactionGroupStartAPI};
